import api from '@axios'

export default {
  namespaced: true,
  state: {
    addressPrincipal: null,
    currentAddress: {
      id: null,
      user_cep: '',
      user_rua: '',
      user_complemento: '',
      user_nmr: '',
      user_bairro: '',
      user_cidade: '',
      user_estado: '',
    },
    address: [],
  },
  getters: {
    getCurrentAddress: state => state.currentAddress,
    getAddress: state => state.address,
    getMaxAddress: state => state.address.length >= 3,
  },
  mutations: {
    SET_ADDRESS_PRINCIPAL(state, payload) {
      const userData = JSON.parse(localStorage.getItem('userData'))
      if (userData) {
        userData.address = payload
        localStorage.setItem('userData', JSON.stringify(userData))
      }
      state.addressPrincipal = payload
    },
    SET_CURRENT_ADDRESS(state, payload) {
      state.currentAddress = payload
    },
    SET_ADDRESS(state, payload) {
      state.address = payload
    },
  },
  actions: {
    reserCuurentAddress({ commit }) {
      commit('SET_CURRENT_ADDRESS', {
        id: null,
        user_cep: '',
        user_rua: '',
        user_complemento: '',
        user_nmr: '',
        user_bairro: '',
        user_cidade: '',
        user_estado: '',
      })
    },
    async updateAddressPrincipal({ commit }, { id_user, id_address }) {
      return new Promise((resolve, reject) => {
        api
          .put(`/usuarios/${id_user}/address/${id_address}/principal`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async findAllUser({ commit }, { id_user }) {
      return new Promise((resolve, reject) => {
        api
          .get(`/usuarios/${id_user}/address`)
          .then(response => {
            const formData = response.data.data

            commit('SET_ADDRESS', formData)
            if (formData.length > 0) {
              commit('SET_CURRENT_ADDRESS', formData.find(address => address.principal === 1))
              commit('SET_ADDRESS_PRINCIPAL', formData.find(address => address.principal === 1))
            }
            resolve(formData)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async findAddressById({ commit }, { id_user, id_address }) {
      return new Promise((resolve, reject) => {
        api
          .get(`/usuarios/${id_user}/address/${id_address}`)
          .then(response => {
            commit('SET_CURRENT_ADDRESS', response.data)
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async createAddress({ commit }, { id_user, data }) {
      return new Promise((resolve, reject) => {
        api
          .post(`/usuarios/${id_user}/address`, data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async updateAddress({ commit }, { id_user, id_address, data }) {
      return new Promise((resolve, reject) => {
        api
          .put(`/usuarios/${id_user}/address/${id_address}`, data)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    async deleteAddress({ commit }, { id_user, id_address }) {
      return new Promise((resolve, reject) => {
        api
          .delete(`/usuarios/${id_user}/address/${id_address}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
